import analytics from "web/script/analytics/analytics";
import baustein from "baustein";
import twoTap from "web/script/embedded/two-tap";
import Matte from "web/script/utils/matte";
import url from "web/script/utils/url";

export default baustein.register("express-checkout", {
    init() {
        twoTap();
    },

    setupEvents(add) {
        add("click", this.onClick);
    },

    onClick(event) {
        event.preventDefault();

        const { dataProductUrl, dataAffiliateLead, dataLinkId } = this.options;
        const thisUrl = url.parse(window.location.href);
        let affiliateUrl = url.parse(dataAffiliateLead);

        analytics.event("express checkout", "clicked", dataLinkId);

        affiliateUrl.protocol = thisUrl.protocol;
        affiliateUrl.host = thisUrl.host;
        affiliateUrl.searchParams.set("session_id", analytics.getSessionId());
        affiliateUrl.searchParams.set("device_id", analytics.getDeviceUid());
        affiliateUrl.searchParams.set("reason", "express-checkout");

        // Don't set Matte to 'blocked', so that it can be dismissed if TwoTap doesn't load
        const matte = new Matte();
        matte.showLoading();
        matte.open();
        twoTap({ url: dataProductUrl, affiliate_link: affiliateUrl.toString() }).then(() => {
            matte.close();
        });
    },
});
